import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Chip} from '@material-ui/core'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'

const styles = (t: Theme) => createStyles({
    chip: {
        margin: t.spacing.unit
    },
});


interface IProps extends WithStyles<typeof styles>,
  WithI18n {
    status: string;
}

class StatusFormSkill extends React.Component<IProps, any> {

  render(){
    const { status, classes } = this.props;
    return(
        <Chip label={this.textRendering(status).text} style={{color: this.textRendering(status).color, backgroundColor: this.textRendering(status).backgroundColor}}  className={classes.chip} />
    )
  }

  private textRendering(status){
    const { t } = this.props;
      switch(status){
        case 'experience':
            return {backgroundColor: '#9500ae', color:'#fff', text: t.EnterpriseDetail_statut_form_skill_experience_lbl}
        case 'connaissance':
            return {backgroundColor: '#ff9100', color:'#000000', text: t.EnterpriseDetail_statut_form_skill_connaissance_lbl}
        case 'non_approprie':
            return {backgroundColor: '#ff1744', color:'#fff', text: t.EnterpriseDetail_statut_form_skill_non_approprie_lbl}
        case 'non_repondu':
            return {backgroundColor: '#a0a0a0', color:'#000000', text: t.EnterpriseDetail_statut_form_skill_non_repondu_lbl}
        case 'approprie':
            return {backgroundColor: '#00e676', color:'#000000', text: t.EnterpriseDetail_statut_form_skill_approprie_lbl}
        case 'approprie (5+)':
            return {backgroundColor: '#00e676', color:'#000000', text: t.EnterpriseDetail_statut_form_skill_approprie_lbl_plus}
        case 'approprie (5-)':
            return {backgroundColor: '#00e676', color:'#000000', text: t.EnterpriseDetail_statut_form_skill_approprie_lbl_minus}    
        default:
            return {};
      }
  }

}

export default compose(
  withI18n,
  withStyles(styles)
)(StatusFormSkill)



// WEBPACK FOOTER //
// ./src/page/Consumer/Enterprise/cards/StatusFormSkill.tsx